import { MOBILE, no_accent } from '@/services/useful';

var $KEYBOARD_EVENTS = 0;


    // SELECT2
        export function select2_reset($class)
        {
            let select = document.querySelectorAll(`select${$class}`);;

            select.forEach(item => {
                if(item.classList.contains('select2-ok')){
                    item.classList.remove('select2-ok');
                    item.parentNode.querySelectorAll('.select2').forEach(item => { item.remove() });
                }
                setTimeout(() => {
                    // let event = document.createEvent("HTMLEvents");
                    // event.initEvent("change", true, false);
                    // item.dispatchEvent(event);
                    select2();
                }, .5);
            })
        }

        export function select2()
        {
            setTimeout(() => {
                // DESK
                    if(!MOBILE()){
                        let $select2s = document.querySelectorAll('select.design');
                        if($select2s.length > 0){
                            $select2s.forEach($item => {
                                if(!$item.classList.contains('select2-ok')){
                                    $item.classList.add('select2-ok');
                                    $item.parentNode.classList.add('posr');   

                                    select2_own($item);
                                }
                            });
                        }
                    }
                // DESK

                // MOBILE
                    else {
                        let $select2s = document.querySelectorAll('select.design');
                        if($select2s.length > 0){
                            $select2s.forEach($item => {
                                if(!$item.classList.contains('select2-ok')){
                                    $item.classList.add('select2-ok');
                                    $item.classList.add('designx');
                                }
                            });
                        }
                    }
                // MOBILE

                // KEYBOARD EVENTS
                    if(!$KEYBOARD_EVENTS){
                        $KEYBOARD_EVENTS = 1;
                        document.addEventListener('keydown', function(e){ // https://www.freecodecamp.org/portuguese/news/lista-de-codigos-de-tecla-em-javascript-codigos-de-tecla-de-evento-de-pressionamento-de-tecla-para-enter-barra-de-espaco-backspace-e-outros/
                            if(event.keyCode == 13){ // ENTER
                                select2_keyboard_enter(e);
                                select_multiple_keyboard_enter(e);

                            } else if(event.keyCode == 38){ // CIMA
                                select2_keyboard_up_down('cima');

                            } else if(event.keyCode == 40){ // BAIXO
                                select2_keyboard_up_down('baixo');

                            } else if(event.keyCode == 9){ // TABS
                                // FECHAR SELECTS ABERTOS
                                    let $e = document.querySelectorAll(`.select2__selected.open`);
                                    if($e){
                                        $e.forEach($item => {
                                            select2_when_to_close($item, 'remove');
                                        });
                                    }
                                    let $e_1 = document.querySelectorAll(`.select2__menu`);
                                    if($e_1){
                                        $e_1.forEach($item => {
                                            $item.style.display = 'none';
                                        });
                                    }
                                // FECHAR SELECTS ABERTOS
                            }
                        });
                    }
                // KEYBOARD EVENTS
            }, .5);
        }


        // SELECT2 (PROPRIO)
            var $select2_offsetTop_cima = 72;
            var $select2_offsetTop_baixo = 300 - 30;
            function select2_own($e){
                select2_createCustomselect2($e);
            }

            function select2_createCustomselect2(select2){
                let select = select2;
                let options = select2.querySelectorAll('option');
                let optionsArr = Array.prototype.slice.call(options);

                let customselect2 = document.createElement('div');
                customselect2.classList.add('select2');
                select2.classList.forEach(function($value, $key){
                    if($value!='design' && $value!='select2-ok'){
                        customselect2.classList.add($value);
                    }
                })
                select2.insertAdjacentElement('afterend', customselect2);

                let selected_input = document.createElement('div');
                selected_input.classList.add('select2__selected_input');
                selected_input.innerHTML = '<input />';
                customselect2.appendChild(selected_input);

                let selected = document.createElement('div');
                selected.classList.add('select2__selected');
                if(select2.value && select2.querySelector(`option[value="${select2.value}"]`) != null){
                    selected.textContent = select2.querySelector(`option[value="${select2.value}"]`).text.replace(/<\/?[^>]+(>|$)/g, "");
                } else {
                    selected.textContent = optionsArr[0].textContent;
                }
                customselect2.appendChild(selected);

                // SELECT EVENTS
                    // select.addEventListener("change", (e) => {
                    //     customselect2.value = e.target.value;
                    // });
                // SELECT EVENTS

                let menu = document.createElement('div');
                menu.classList.add('select2__menu');
                menu.classList.add('no_sel');
                customselect2.appendChild(menu);
                selected.addEventListener('click', select2_toggleselect2.bind(menu));

                let search = document.createElement('input');
                search.placeholder = 'Pesquisar...';
                search.type = 'text';
                search.classList.add('select2__menu_search');
                menu.appendChild(search);

                let menuItemsWrapper = document.createElement('div');
                menuItemsWrapper.classList.add('select2__menu_items');
                menu.appendChild(menuItemsWrapper);

                let menuItemsWrapper_1 = document.createElement('div');
                menuItemsWrapper_1.classList.add('select2__no_result');
                let menuItemsWrapper_2 = document.createElement('div');
                menuItemsWrapper_2.classList.add('select2__menu_item_no_result');
                menuItemsWrapper_2.innerHTML = 'Nenhum resultado encontrado...';
                menuItemsWrapper_1.appendChild(menuItemsWrapper_2);
                menuItemsWrapper_1.style.display = 'none';
                menu.appendChild(menuItemsWrapper_1);

                select2_auto_complete_ini(select2, menu);

                select2_items(optionsArr, select2, menu, selected, menuItemsWrapper);

                search.addEventListener('input', select2_filterItems.bind(search, optionsArr, menu));
                document.addEventListener('click', select2_closeIfClickedOutside.bind(customselect2, menu));
                menuItemsWrapper.addEventListener('mouseover', select2_closeIfClickedOutside_hover.bind(customselect2, menu));
                //select2.style.display = 'none';

                select2_items_focus_tabs(select2, customselect2, menu);
            }

            // ITEMS
                function select2_items(optionsArr, select2, menu, selected, menuItemsWrapper){
                    optionsArr.forEach(option => {
                        let item = document.createElement('div');
                        item.classList.add('select2__menu_item');
                        item.dataset.value = option.value;
                        item.innerHTML = select2_option_name(select2, option.textContent);
                        menuItemsWrapper.appendChild(item);

                        if(select2.value == item.getAttribute('data-value')){
                            menuItemsWrapper.querySelector(`[data-value="${select2.value}"]`).classList.add('selected');
                        }

                        item.addEventListener('click', select2_setSelected.bind(item, selected, select2, menu));
                    });
                }
            // ITEMS

            // FOCUS TABS
                var $no_focus_select2 = 0
                function select2_items_focus_tabs(select2, customselect2, menu){
                    let $e = customselect2.querySelector(`.select2__selected_input input`);
                    if($e){
                        $e.addEventListener("focus", (e) => {
                            let $e_1 = customselect2.querySelector(`.select2__menu`);
                            if($e_1){
                                // ABRIR
                                    //select2_open($e_1);
                                // ABRIR
                            }
                        });
                        select2.addEventListener("focus", (e) => {
                            let $e_1 = customselect2.querySelector(`.select2__menu`);
                            if($e_1 && !$no_focus_select2){
                                // ABRIR
                                    //select2_open($e_1);
                                // ABRIR
                            }
                            $no_focus_select2 = 0;
                        });
                    }
                }
            // FOCUS TABS

            // QUANDO CLICA NO BOX PRINCIPAL (SELECT) PARA APARECER OS ITENS (OPTION)
                function select2_toggleselect2(){
                    if (this.offsetParent !== null){
                        this.style.display = 'none';
                        select2_when_to_close(this.parentNode.querySelector(".select2__selected"), 'remove');

                    } else {
                        select2_open(this);
                    }
                }
            // QUANDO CLICA NO BOX PRINCIPAL (SELECT) PARA APARECER OS ITENS (OPTION)

            // ABRIR SELECT
                function select2_open($this){
                    $this.parentNode.querySelector('.select2__menu_search').value = '';
                    $this.parentNode.querySelector('.select2__menu_search').dispatchEvent(new Event('input'));

                    $this.style.display = 'block';
                    select2_when_to_close($this.parentNode.querySelector(".select2__selected"), 'add');
                    selected_first_option($this);

                    // VERIFICAR SE ABRE TOP OU BOTTOM
                        let $pos = document.body.getBoundingClientRect();
                        let $this_pos = $this.parentNode.getBoundingClientRect();

                        if($this_pos.top > ($pos.height+$pos.top-280)){
                            $this.classList.add('bottom');
                        } else {
                            $this.classList.remove('bottom');
                        }
                    // VERIFICAR SE ABRE TOP OU BOTTOM

                    setTimeout(function(){ $this.querySelector('input').focus(); }, .5);
                }
            // ABRIR SELECT


            // SELECIONANDO A PRIMEIRA OPCAO
                function selected_first_option($this){
                    document.querySelectorAll(".select2__menu .select2__menu_items .select2__menu_item").forEach(value => {
                        value.classList.remove('select2_dn');
                        value.classList.remove('select2__menu_item__hoverr');
                    });
                    let $e = $this.parentNode.querySelector(".select2__menu .select2__menu_items .select2__menu_item.selected");
                    if($e){
                        $e.classList.add('select2__menu_item__hoverr');

                        let $scroll_ = $e.offsetTop - $select2_offsetTop_cima;
                        $this.parentNode.querySelector(".select2__menu .select2__menu_items").scrollTo({ top: $scroll_, behavior: 'smooth'});
                    }		        		
                }
            // SELECIONANDO A PRIMEIRA OPCAO

            // QUANDO SELECIONA O ITEM
                function select2_setSelected(selected, select2, menu){
                    let value = this.dataset.value;
                    let label = this.textContent;

                    selected.textContent = label;
                    select2.value = value;
                    select2.dispatchEvent(new Event('change'));

                    // QUANDO SELECIONA O ITEM
                        menu.style.display = 'none';
                        menu.querySelector('.select2__no_result').style.display = 'none';
                        select2_when_to_close(menu.parentNode.querySelector(".select2__selected"), 'remove');
                        menu.querySelector('input').value = '';
                        menu.querySelectorAll('div').forEach(div => {
                            if (div.classList.contains('selected')){
                                div.classList.remove('selected');
                            }
                            if (div.offsetParent === null){
                                div.style.display = 'block';
                            }
                        });
                        this.classList.add('selected');

                        $no_focus_select2 = 1;
                        setTimeout(function(){ $no_focus_select2 = 0; }, .5);
                    // QUANDO SELECIONA O ITEM
                }
            // QUANDO SELECIONA O ITEM

            // QUANDO DIGITA NO INPUT
                function select2_filterItems(itemsArr, menu){
                    let customOptions = menu.querySelectorAll('.select2__menu_items div');
                    let value = this.value.toLowerCase();
                    let filteredItems = itemsArr.filter(item => no_accent(item.innerHTML.toLowerCase()).includes(no_accent(value)));
                    let indexesArr = filteredItems.map(item => itemsArr.indexOf(item));

                    // FILTER (QUANDO DIGITA ALGO)
                        itemsArr.forEach(option => {
                            if (!indexesArr.includes(itemsArr.indexOf(option))){
                                let $e = customOptions[itemsArr.indexOf(option)];
                                if($e){
                                    $e.style.display = 'none';
                                    $e.classList.add('select2_dn');
                                }
                            } else {
                                if(customOptions[itemsArr.indexOf(option)]){
                                    if(customOptions[itemsArr.indexOf(option)].offsetParent === null){
                                        let $e = customOptions[itemsArr.indexOf(option)];
                                        $e.style.display = 'block';
                                        $e.classList.remove('select2_dn');
                                    }
                                }
                            }
                        });
                    // FILTER (QUANDO DIGITA ALGO)

                    // TIRANDO select2__menu_item__hoverr E COLOCANDO NO PRIMEIRO DA LISTA
                        let $e = menu.querySelector('.select2__menu_items .select2__menu_item:not(.select2_dn)');
                        if($e){
                            menu.querySelector('.select2__no_result').style.display = 'none';

                            menu.querySelector('.select2__menu_items').scrollTo({ top: 0, behavior: 'smooth'});

                            menu.querySelectorAll('.select2__menu_items .select2__menu_item').forEach(value => {
                                value.classList.remove('select2__menu_item__hoverr');
                            });
                            $e.classList.add('select2__menu_item__hoverr');
                        } else {
                            menu.querySelector('.select2__no_result').style.display = 'block';
                        }
                    // TIRANDO select2__menu_item__hoverr E COLOCANDO NO PRIMEIRO DA LISTA

                    select2_auto_complete__menu_items(menu.parentNode.previousElementSibling, menu);
                }
            // QUANDO DIGITA NO INPUT

            // TIRAR CONFIGS QUANDO FECHAR
                function select2_when_to_close($e, $tipo){
                    if($tipo == 'add'){
                        $e.classList.add('open')
                    } else {
                        $e.classList.remove('open')
                    }
                    $e.parentNode.querySelector('.select2__no_result').style.display = 'none';

                    $no_focus_select2 = 1;
                    setTimeout(function(){ $no_focus_select2 = 0; }, .5);
                }
            // TIRAR CONFIGS QUANDO FECHAR

            // QUANDO CLICA FORA DA TELA (FECHAR TUDO)
                function select2_closeIfClickedOutside(menu, e){
                    if(!e.target.classList.contains('select2-ok') && !e.target.classList.contains('select2__menu') && !e.target.classList.contains('select2__menu_search')  && !e.target.classList.contains('select2__menu_items') && !e.target.classList.contains('select2__menu_item') && !e.target.classList.contains('select2__no_result') && !e.target.classList.contains('select2__menu_item_no_result')){
                        // FECHAR SELECT2 SE CLICAR FORA
                            if(e.target.closest('.select2__selected') === null && e.target !== this && menu.offsetParent !== null){
                                menu.style.display = 'none';
                                select2_when_to_close(menu.parentNode.querySelector(".select2__selected"), 'remove');

                            }
                        // FECHAR SELECT2 SE CLICAR FORA
                        // FECHAR OUTROS SELECT2 SE CLICAR EM ALGUM SELECT2
                            if(e.target !== this.querySelector('.select2__selected')){
                                menu.style.display = 'none';
                                select2_when_to_close(menu.parentNode.querySelector(".select2__selected"), 'remove');
                            }
                        // FECHAR OUTROS SELECT2 SE CLICAR EM ALGUM SELECT2

                        //select2_auto_complete__menu_items(menu.parentNode.querySelector(".select2__selected").parentNode.previousElementSibling, menu.parentNode.querySelector(".select2__selected").parentNode.querySelector('.select2__menu'));
                    }
                }
            // QUANDO CLICA FORA DA TELA (FECHAR TUDO)

            // HOVERR
                function select2_closeIfClickedOutside_hover(menu, e){
                    if(e.target.classList.contains('select2__menu_item')){
                        let $e_1 = e.target.parentNode.querySelector(".select2__menu_item__hoverr");
                        if($e_1){
                            $e_1.classList.remove('select2__menu_item__hoverr');
                        }
                        e.target.classList.add('select2__menu_item__hoverr');
                    }
                }
            // HOVERR

            // OPTION NOME
                function select2_option_name($select, $nome){
                    let $return = $nome;
                    if($select.getAttribute('name') == 'icone' || $select.getAttribute('name') == 'icones' || $select.getAttribute('name') == 'icones_1' || $select.getAttribute('name') == 'icones_2' || $select.getAttribute('name') == 'icones_3' || $select.getAttribute('name') == 'icones_4' || $select.getAttribute('name') == 'icones_5' || $select.getAttribute('name') == 'icones_6' || $select.getAttribute('name') == 'icones_7' || $select.getAttribute('name') == 'icones_8' || $select.getAttribute('name') == 'icones_9' || $select.getAttribute('name') == 'icones_10'){
                        $return = `<i class="${$return}"></i> &nbsp; ${$return}`;
                    }
                    return $return;
                }
            // OPTION NOME


            // AUTO COMPLETE
                function select2_auto_complete_ini(select2, menu){
                    if(select2){
                        if(select2.hasAttribute('autocomplete')){
                            let menuItemsWrapper_3 = document.createElement('div');
                            menuItemsWrapper_3.classList.add('select2__auto_complete');
                            let menuItemsWrapper_4 = document.createElement('div');
                            menuItemsWrapper_4.classList.add('select2__menu_item_auto_complete');
                            menuItemsWrapper_4.innerHTML = 'Digite 2 ou mais caracteres';
                            menuItemsWrapper_3.appendChild(menuItemsWrapper_4);
                            menu.appendChild(menuItemsWrapper_3);
                        }
                    }
                }
                async function select2_auto_complete__menu_items(select2, menu){
                    if(select2){
                        if(select2.hasAttribute('autocomplete')){
                            let $length = menu.querySelector('.select2__menu_search').value.length;
                            if($length < 2){
                                menu.querySelector('.select2__menu_items').style.display = 'none';
                                menu.querySelector('.select2__no_result').style.display = 'none';
                                menu.querySelector('.select2__auto_complete').style.display = 'block';

                            } else {
                                menu.querySelector('.select2__auto_complete').style.display = 'none';
                                menu.querySelector('.select2__menu_items').style.display = 'block';

                                // AJAX
                                    await ajax(`autocomplete/.php`, {table: select2.getAttribute('name'), busca: menu.querySelector('.select2__menu_search').value}, function ($request){
                                        let $option = '';
                                        $request?.itens?.map(function($value, $key){
                                            $option += `<option value="${$value.id}">${$value.value}</option>`;
                                        })

                                        select2.innerHTML = $option;
                                        let options_ = select2.querySelectorAll('option');
                                        let optionsArr_ = Array.prototype.slice.call(options_);
                                        menu.querySelector('.select2__menu_items').innerHTML = '';

                                        let $selected = menu.parentNode.querySelector('.select2__selected');
                                        select2_items(optionsArr_, select2, menu, $selected, menu.querySelector('.select2__menu_items'))

                                        // TIRANDO select2__menu_item__hoverr E COLOCANDO NO PRIMEIRO DA LISTA
                                            let $e = menu.querySelector('.select2__menu_items .select2__menu_item:not(.select2_dn)');
                                            if($e){
                                                menu.querySelector('.select2__no_result').style.display = 'none';

                                                menu.querySelector('.select2__menu_items').scrollTo({ top: 0, behavior: 'smooth'});

                                                menu.querySelectorAll('.select2__menu_items .select2__menu_item').forEach(value => {
                                                    value.classList.remove('select2__menu_item__hoverr');
                                                });
                                                $e.classList.add('select2__menu_item__hoverr');
                                            } else {
                                                menu.querySelector('.select2__no_result').style.display = 'block';
                                            }
                                        // TIRANDO select2__menu_item__hoverr E COLOCANDO NO PRIMEIRO DA LISTA

                                        load_close();
                                    });
                                // AJAX
                            }
                        }
                    }
                }
            // AUTO COMPLETE


            // KEYBOARD
                function select2_keyboard_up_down($tipo){
                    let $e = document.querySelector(".select2__menu .select2__menu_items .select2__menu_item.select2__menu_item__hoverr");
                    if($e){
                        let $e_1 = $tipo=='cima' ? $e.previousElementSibling : $e.nextElementSibling;

                        // verificando se a um filter (pegar proximo arquivo sem .select2_dn)
                        for(let $i = 0; $i < 1000; $i++){
                            if($e_1 == null){ $i = 1000;
                            } else {
                                if($e_1.classList.contains('select2_dn')){
                                    $e_1 = $tipo=='cima' ? $e_1.previousElementSibling : $e_1.nextElementSibling;
                                }
                            }
                        }

                        if($e_1){
                            $e_1.focus();

                            let $scroll_ = $tipo=='cima' ? ($e.offsetTop - $select2_offsetTop_cima) : ($e.offsetTop - $select2_offsetTop_baixo);
                            $e_1.parentNode.scrollTo({ top: $scroll_, behavior: 'smooth'});

                            $e_1.classList.add('select2__menu_item__hoverr');
                            $e.classList.remove('select2__menu_item__hoverr');
                        }
                    }
                }
                function select2_keyboard_enter(e){
                    let $e = e.target;
                    if($e){
                        if($e.classList.contains('select2__menu_search')){
                            event.preventDefault();
                            let $e_1 = document.querySelector(".select2__menu .select2__menu_items .select2__menu_item.select2__menu_item__hoverr");
                            if($e_1){
                                $e_1.dispatchEvent(new Event('click'));
                            }
                        }
                    }
                }
            // KEYBOARD
        // SELECT2 (PROPRIO)
    // SELECT2







    // MULTIPLE
        export function select_multiple_search($e)
        {
            let $value = $e.value;
            let $options = $e.parentNode.querySelectorAll('select option');
            let $itemsArr = Array.prototype.slice.call($options);

            let $filteredItems = $itemsArr.filter(item => no_accent(item.innerHTML.toLowerCase()).includes(no_accent($value)));
            let $indexesArr = $filteredItems.map(item => $itemsArr.indexOf(item));

            $itemsArr.forEach(option => {
                if (!$indexesArr.includes($itemsArr.indexOf(option))){
                    option.style.display = 'none';
                } else {
                    option.style.display = 'block';
                }
            });

        }
        export function select_multiple_add($e)
        {
            let $select = $e.parentNode.parentNode.querySelector('select.multiple__temp');
            let $values = $select.querySelectorAll('select.multiple__temp option:checked');
            if($values){
                let $e_1 = $e.parentNode.parentNode.querySelector('select.multiple__real');
                select_multiple_mover($select, $e_1, $values);
            }
        }
        export function select_multiple_remove($e)
        {
            let $select = $e.parentNode.parentNode.querySelector('select.multiple__real');
            let $values = $select.querySelectorAll('option:checked');
            if($values){
                let $e_1 = $e.parentNode.parentNode.querySelector('select.multiple__temp');
                select_multiple_mover($select, $e_1, $values);
            }
        }
        function select_multiple_mover($select, $e_1, $values){
            if($e_1){
                $values.forEach($value => {
                    let $e_2 = $select.querySelectorAll(`option[value="${$value.value}"]`);
                    if($e_2){
                        $e_2.forEach(value => {
                            $e_1.appendChild(value);
                        });
                    }
                });
                select_multiple_order($e_1);
            }
        }
        function select_multiple_order($select){
            let $itemsArr = Array.prototype.slice.call($select);
            $itemsArr.sort(function(a,b){
                return a.text == b.text  ? 0 : a.text < b.text ? -1 : 1;
            });

            $select.innerHTML = '';
            $itemsArr.map(function($val, $key){
                $select.appendChild($val);
            });
        }
        function select_multiple_keyboard_enter(e){
            let $e = e.target;
            if($e){
                if($e.classList.contains('multiple__search')){
                    event.preventDefault();
                }
                if($e.classList.contains("multiple__temp")){
                    event.preventDefault();
                    let $select = $e;
                    let $values = $select.querySelectorAll('option:checked');
                    if($values){
                        let $e_1 = $select.parentNode.parentNode.querySelector('select.multiple__real');
                        select_multiple_mover($select, $e_1, $values);
                    }
                }
                if($e.classList.contains("multiple__real")){
                    event.preventDefault();
                    let $select = $e;
                    let $values = $select.querySelectorAll('option:checked');
                    if($values){
                        let $e_1 = $select.parentNode.parentNode.querySelector('select.multiple__temp');
                        select_multiple_mover($select, $e_1, $values);
                    }
                }
            }
        }
    // MULTIPLE
